import React from 'react';
import { Quote } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  role: string;
  location: string;
  content: string;
  age: number;
}
export function TestimonialCard({
  name,
  role,
  location,
  content,
  age
}: TestimonialCardProps) {
  return <div className="bg-purple-50 rounded-2xl p-8 relative" data-id="element-204">
      <Quote className="absolute top-6 left-6 w-8 h-8 text-purple-200" data-id="element-205" />
      <div className="relative z-10" data-id="element-206">
        <p className="text-gray-700 italic mb-6 text-lg leading-relaxed" data-id="element-207">
          "{content}"
        </p>
        <div className="flex items-center gap-4" data-id="element-208">
          <div className="w-12 h-12 bg-purple-200 rounded-full flex items-center justify-center text-purple-700 font-bold text-xl" data-id="element-209">
            {name.charAt(0)}
          </div>
          <div data-id="element-210">
            <h4 className="font-bold text-gray-900" data-id="element-211">
              {name}, {age}
            </h4>
            <p className="text-sm text-gray-600" data-id="element-212">{role}</p>
            <p className="text-xs text-gray-500" data-id="element-213">{location}</p>
          </div>
        </div>
      </div>
    </div>;
}